import alertIconSrc from './alert-icon.svg';
import attentionIconSrc from './attention-icon.svg';
import checkIconSrc from './check-icon.svg';
import noStatusIconSrc from './no-status-icon.svg';
import progressIconSrc from './progress-icon.svg';

export const statuses = {
    alert: alertIconSrc,
    attention: attentionIconSrc,
    check: checkIconSrc,
    progress: progressIconSrc,
    no: noStatusIconSrc,
};
